import { ICON_MAP } from "./IconMap";

export type IconType = keyof typeof ICON_MAP;

export function isIconType(key: any): key is IconType {
  return typeof key === "string" && key in ICON_MAP;
}

type Props = React.SVGProps<SVGSVGElement> & {
  type: IconType;
};

export function Icon({ type, ...svgProps }: Props): JSX.Element {
  const Component = ICON_MAP[type];
  return <Component {...svgProps} />;
}
